import React from 'react'

export default function Stack() {
  return (
    <div className="stack">
        <p className="stack-des">Tech Stack </p>
        <ul className="stack-list">
            <li className="stack-item">
                <i className="bx bxl-html5 stack-icon"></i>
            </li>

            <li className="stack-item">
                <i className="bx bxl-css3 stack-icon"></i>
            </li>

            <li className="stack-item">
                <i className="bx bxl-javascript stack-icon"></i>
            </li>

            <li className="stack-item">
                <i className="bx bxl-typescript stack-icon"></i>
            </li>

            <li className="stack-item">
                <i className="bx bxl-react stack-icon"></i>
            </li>

            <li className="stack-item">
                <i className="bx bxl-nodejs stack-icon"></i>
            </li>
        </ul>
    </div>
  )
}
